import _extends from "@babel/runtime-corejs3/helpers/extends";
import { features } from '@kdcloudjs/table';
function useRangeSelection(pipeline, rangeSelection) {
  if (rangeSelection) {
    pipeline.use(features.rangeSelection(_extends({}, rangeSelection)));
  }
}
export default useRangeSelection;